import React from 'react';
import T from 'prop-types';

const Chevron = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="16"
      viewBox="0 0 26 16"
    >
      <path
        className={props.className}
        fill={props.fillColor}
        fillRule="evenodd"
        d="M13 5.984l-8.033 7.988c-.81.806-2.125.806-2.936 0-.81-.806-.81-2.113 0-2.92l9.501-9.447c.81-.807 2.125-.807 2.936 0l9.5 9.448c.812.806.812 2.113 0 2.92-.81.805-2.124.805-2.935 0L13 5.982z"
      />
    </svg>
  );
};

Chevron.defaultProps = {
  fillColor: '#01A5A3',
  className: 'svg-path-chevron',
};

Chevron.propTypes = {
  fillColor: T.string,
  className: T.string,
};

export default Chevron;
